import {Store} from "vuex";

const api_url = process.env.VUE_APP_ROOT_API;

interface BasicCredentials {
    username: string;
    password: string;
}

export async function apiQuery(endpoint: string, params?: Record<string, string | number | boolean | undefined>, options?: RequestInit): Promise<Response> {
    const queryString = params ? `?${buildQueryString(params)}` : "";
    const url = `${api_url}${endpoint}${queryString}`;
    const credentials = JSON.parse(localStorage.getItem("credentials") || "null") as BasicCredentials | null;
    if (credentials) {
        const authHeader = "Basic " + btoa(`${credentials.username}:${credentials.password}`);
        options = {
            ...options,
            headers: {
                ...options?.headers,
                Authorization: authHeader,
            },
        };
    }
    const response = await fetch(url, options);
    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`API request failed: ${response.status} ${response.statusText} - ${errorText}`);
    }
    return response;
}

export function asJson<T>(response: Response): Promise<T> {
    return response.json() as Promise<T>;
}

export async function downloadAsFile(filename: string, response: Response): Promise<void> {
    const url = window.URL.createObjectURL(await response.blob());
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename); //or any other extension
    document.body.appendChild(link);
    link.click();
}

export function logError(store: Store<any>, message: string, e: any): void {
    console.error("An error occurred", e);
    console.error("Pushing error message to store: ", message);
    const msg_obj = {
        type: "ERROR",
        message: message
    };
    store.commit('add_message', msg_obj);
}

export function buildQueryString(params: Record<string, string | number | boolean | undefined>): string {
    const query = new URLSearchParams();
    for (const key in params) {
        const value = params[key];
        if (value !== undefined) {
            query.append(key, String(value));
        }
    }
    return query.toString();
}